import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';
import { children, media, palette } from 'util/style-helpers';

export const style: any = (styles?: IGenericObject) => {
  return StyleSheet.create({
    container: {
      height: '100%',
      position: 'relative',
      // boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
    },
    bioContainer: {
      flexGrow: 1,
      overflowY: 'scroll',
      paddingRight: 15,
      [media.tablet]: {
        paddingRight: 30,
      },
      [media.desktop]: {
        paddingRight: 50,
      },
    },
    bioSeparator: {
      marginTop: 20,
      marginBottom: 40,
      border: `1px solid ${palette.red}`,
    },
    navigationContainer: {
      minHeight: 'fit-content',
      display: 'flex',
      flexWrap: 'nowrap',
      width: '100%',
      marginTop: 20,
      [media.smallerThanTablet]: {
        paddingRight: 15,
      },
    },
    button: {
      display: 'flex',
      margin: '10px 0',
      padding: 0,
      position: 'relative',
      justifyContent: 'center',
      fontSize: 14,
      fontWeight: 'bold',
      verticalAlign: 'center',
      backgroundColor: 'transparent',
      border: 'none',
      borderBottom: '2px solid transparent',
      transition: 'all 0.3s linear',
      borderRadius: 'none',
      [children('span')]: {
        margin: 'auto 0',
        height: 16,
      },
      [children('svg')]: {
        height: '100%',
        width: 'auto',
        fill: palette.red,
      },
      ':focus': {
        outline: 'none',
      },
      [media.desktop]: {
        ':after': {
          content: '""',
          position: 'absolute',
          top: 'calc(100% + 4px)',
          left: '0',
          height: '2px',
          width: 0,
          backgroundColor: palette.red,
          transition: 'width .25s linear',
        },
        ':hover': {
          ':after': {
            width: '100%',
          },
        },
      },
    },
    previousButton: {
      marginRight: 10,
      textAlign: 'left',
      [children('span')]: {
        transition: 'all 0.2s linear',
        marginLeft: 5,
        marginRight: 5,
      },
      ':hover': {
        [children('span')]: {
          marginLeft: 0,
          marginRight: 10,
        },
      },
    },
    nextButton: {
      marginLeft: 'auto',
      textAlign: 'right',
      [children('span')]: {
        transition: 'all 0.2s linear',
        marginLeft: 5,
        marginRight: 5,
      },
      ':hover': {
        [children('span')]: {
          marginLeft: 10,
          marginRight: 0,
        },
      },
    },
  });
};
